import React from 'react'
import { Icon } from 'antd'
import { Link } from 'react-router-dom'

import css from './index.scss'

const getLinkedVehiclePath = (linkedVehicleInfo) => {
  if (!linkedVehicleInfo) return null

  return linkedVehicleInfo.deliveryType === 'LOT'
    ? `/loads/${linkedVehicleInfo.shippingHash}/details/delivery/${linkedVehicleInfo.deliveryId}`
    : `/loads/${linkedVehicleInfo.shippingHash}/details`
}

export const VehicleBindAlerts = ({
  vehicle,
  isPrimary,
  flEnableCheckRntrc,
  linkedVehicleInfo,
  editVehiclePath,
}) => {
  if (!vehicle) return null

  const linkedPath = getLinkedVehiclePath(linkedVehicleInfo)
  const hasLinkedInfo = linkedVehicleInfo && Object.keys(linkedVehicleInfo).length > 0

  return (
    <div className={css.alerts}>
      {vehicle.flBlock && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>
            Veículo possui uma restrição cadastrada no Embarcador dessa carga
          </span>
        </div>
      )}
      {hasLinkedInfo &&
        (linkedVehicleInfo.externalId ? (
          <div className={css.alert}>
            <Icon type="warning" fill="#F62144" />
            <span className={css.alertText}>O veículo está vinculado à carga:</span>
            <Link className={css.link} to={linkedPath} target="_blank">
              {linkedVehicleInfo.externalId}
            </Link>
          </div>
        ) : (
          <div className={css.alert}>
            <Icon type="warning" fill="#F62144" />
            <span className={css.alertText}>O veículo está vinculado a outra carga.</span>
          </div>
        ))}
      {vehicle.flWithoutTag && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>
            Veículo não possui Tag cadastrada
          </span>
        </div>
      )}
      {vehicle.flRenavanInvalid && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>RENAVAM inválido.</span>
          <Link className={css.link} to={editVehiclePath} target="_blank">
            Clique para editar
          </Link>
        </div>
      )}
      {vehicle.flVehicleTypeInvalid && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>O tipo de veículo é inconsistente.</span>
          <Link className={css.link} to={editVehiclePath} target="_blank">
            Clique para editar
          </Link>
        </div>
      )}
      {isPrimary && flEnableCheckRntrc && (!vehicle.rntrc || !vehicle.validatedRntrc) && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>RNTRC inválida.</span>
          <Link className={css.link} to={editVehiclePath} target="_blank">
            Clique para editar
          </Link>
        </div>
      )}
      {vehicle.flUfInvalid && (
        <div className={css.alert}>
          <Icon type="warning" fill="#F62144" />
          <span className={css.alertText}>UF inválido.</span>
          <Link className={css.link} to={editVehiclePath} target="_blank">
            Clique para editar
          </Link>
        </div>
      )}
    </div>
  )
}
